import { render, staticRenderFns } from "./ProfileEligibilityIcon.vue?vue&type=template&id=766f1a13"
import script from "./ProfileEligibilityIcon.vue?vue&type=script&lang=js"
export * from "./ProfileEligibilityIcon.vue?vue&type=script&lang=js"
import style0 from "./ProfileEligibilityIcon.vue?vue&type=style&index=0&id=766f1a13&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports